import { render, staticRenderFns } from "./MlPageTable.vue?vue&type=template&id=93a67ad6"
import script from "./MlPageTable.vue?vue&type=script&lang=js"
export * from "./MlPageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports